import React, { useContext } from 'react';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { CalendarDaysList } from './CalendarDaysList.js';
import { CalendarContext } from './CalendarContext.js';

export const CalendarMonthDays = (): JSX.Element => {
  const { invisibleFirstDay, daysMatrixByWeekday, invisibleLastDay } = useContext(CalendarContext);
  const { calendarDaysWrapperRef } = useContext(ControlledDateTimePickerContext);

  return (
    <CalendarDaysList
      invisibleFirstDay={invisibleFirstDay}
      daysMatrixByWeekday={daysMatrixByWeekday}
      invisibleLastDay={invisibleLastDay}
      innerRef={calendarDaysWrapperRef}
    />
  );
};
